import { onYoutubeReady } from './youtubeApi.js';
import { trackEvent } from './utils.js';

export function addVideoPlayer(element) {

  const playButton = element.querySelector('.video-cover-button')
  const videoID = element.getAttribute('data-video-id')

  onYoutubeReady(function () {

    const vid = new YT.Player(element.querySelector('.youtube-iframe'), {
      videoId: videoID,
      playerVars: {
        controls: 0,
        modestbranding: 1,
        rel: 0,
        showinfo: 0
      },
      events: {

        onReady: function () {
          element.classList.add('show')
          playButton.classList.add('is-visible')
        },

        onStateChange: function (event) {

          if(event.data === YT.PlayerState.PLAYING) {
            playButton.classList.remove('is-visible')
            element.classList.remove('loading')
            trackEvent({ type: 'video', ev: 'play', val: vid.getVideoData().title })
          } 
          else if(event.data === YT.PlayerState.BUFFERING) {
            element.classList.add('loading')
          } 
          else if (event.data === YT.PlayerState.PAUSED) {
            vid.stopVideo()
          }
          else {
            playButton.classList.add('is-visible')
          }

        }
      }
    })
  })

}


// WEBPACK FOOTER //
// ./src/videoPlayer.js